
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";
import { AppActions } from "../../types";
import { GET_CMS, SET_CMS_DATA,RESET_CMS_DATA } from "types/actions/cmsMaster.action";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentCms: CmsMasterData | null;
  cms: CmsMasterData[];
  cmsCount: number;
 
} = {
  currentCms: null,
  cms: [],
  cmsCount: 0,
  
};

const CmsMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    // Plan-related actions
    case "GET_CMS":
      return {
        ...state,
        cms: action.payload.cms,
        cmsCount: action.payload.count,
      };
    case SET_CMS_DATA:
      return {
        ...state,
        currentCms: action.payload,
      };
      case RESET_CMS_DATA:
        return { ...state, currentCms: null };
    default:
      return state; 
  }
};

export default CmsMaster;
